import { em } from "csx";
import { classNames } from "./utils.js";
import { style, stylesheet } from "typestyle";
import * as React from "react";
import { useMemo } from "react";
export function Avatar({ children, primary, success, warning, error, size, onClick }) {
    const colorClass = useMemo(() => {
        if (primary) {
            return styles.primary;
        }
        if (success) {
            return styles.success;
        }
        if (warning) {
            return styles.warning;
        }
        if (error) {
            return styles.error;
        }
        return styles.default;
    }, [primary, success, warning, error]);
    const sizeClass = useMemo(() => size ? style({ fontSize: em(size) }) : undefined, [size]);
    const handleClick = (e) => {
        if (onClick) {
            e.stopPropagation();
            e.preventDefault();
            onClick();
        }
    };
    return (React.createElement("i", { className: classNames(styles.avatar, colorClass, sizeClass), onClick: handleClick }, children));
}
const styles = stylesheet(({
    avatar: {
        display: "block",
        borderRadius: "50%",
        textAlign: "center",
        width: "2em",
        height: "2em",
        lineHeight: 2,
        fontSize: "1em",
        fontWeight: 300
    },
    default: {
        backgroundColor: "var(--color-foreground)",
        color: "var(--color-background)",
    },
    primary: {
        backgroundColor: "var(--color-primary)",
        color: "#fff",
    },
    success: {
        backgroundColor: "var(--color-success)",
        color: "#fff",
    },
    warning: {
        backgroundColor: "var(--color-warning)",
        color: "#fff",
    },
    error: {
        backgroundColor: "var(--color-error)",
        color: "#fff",
    }
}));
//# sourceMappingURL=Avatar.js.map